import { createAction } from 'redux-act';

export const resetPassword = createAction('ACTIONS__RESET_PASSWORD');

export { default as saga } from './saga.js';
